import { FC, ReactNode, useEffect } from 'react';
import { $Formutil, connect } from 'react-bootstrap-formutil';
import Skeleton from 'components/base/Skeleton';
import ErrorBox from 'components/ErrorBox';
import FormGroup, { FormGroupProps } from 'components/FormGroup';
import WeakNetPrompt from 'components/forms/WeakNetPrompt';
import FormSelect from 'components/FormSelect';
import { FormCheckNumberType, IdTypeInfoCategoryEnum } from 'types/common';
import { CustomerInfoKeyType, IdTypeEnum } from 'types/customer';
import { useGetIdTypeList } from './hook';

export interface IdTypeProps extends FormGroupProps {
    label?: ReactNode;
    disabled?: boolean;
    issueCountry: string;
    $formutil: $Formutil<IdTypeFormutil>;
}

export interface IdTypeFormutil {
    id_type: IdTypeEnum;
}

export const defaultFieldsOfIdType: CustomerInfoKeyType[] = ['id_type'];

export interface IdTypeItem {
    id_type: IdTypeEnum;
    name: string;
    // 是否有地址 0：没有 1：有
    has_address: FormCheckNumberType;
    // 是否有有效期 0：没有 1：有
    has_expire_date: FormCheckNumberType;
    sides: number; // 1 该证件只有一张图，2有正反面
}

const IdType: FC<IdTypeProps> = ({
    label = __('Document Type'),
    issueCountry,
    disabled,
    $defaultValue,
    $formutil,
    ...restProps
}) => {
    const {
        $params: { id_type: formIdType },
        $setValues
    } = $formutil;
    const { data, isLoading, error, mutate } = useGetIdTypeList(IdTypeInfoCategoryEnum.ID_TYPE, issueCountry);

    useEffect(() => {
        if (formIdType && data) {
            const isIdTypeInList: boolean = data.some(item => item.id_type === formIdType);

            // 如果当前选择的证件类型不在列表中，则重置证件类型
            if (!isIdTypeInList) {
                $setValues({
                    id_type: IdTypeEnum.EMPTY
                });
            }
        }
    }, [formIdType, data, $setValues]);

    if (error) {
        return (
            <div className="mb-3">
                <ErrorBox error={error} onClick={() => mutate()} />
                {/* loading/error状态下不能直接提交,需要拦截一下 */}
                <WeakNetPrompt name="temporary_id_type" type="error" />
            </div>
        );
    }

    if (isLoading) {
        return (
            <div className="mb-3">
                <Skeleton line={2} />
                {/* loading状态下不能直接提交,需要拦截一下 */}
                <WeakNetPrompt name="temporary_id_type" type="loading" />
            </div>
        );
    }

    return data ? (
        <FormGroup
            label={label}
            name="id_type"
            checker={(value: string) => {
                if (disabled) {
                    return true;
                }

                return !!value || __('请选择证件类型');
            }}
            $defaultValue={typeof $defaultValue === 'undefined' ? data[0].id_type : $defaultValue}
            {...restProps}>
            <FormSelect
                disabled={disabled}
                options={data.map(item => ({
                    value: item.id_type,
                    label: item.name
                }))}
                placeholder={__('请选择证件类型')}
            />
        </FormGroup>
    ) : null;
};

export default connect(IdType);
export * from './hook';
